
import React, { Component } from "react";
import AlbumsData from '../data/AlbumsData'

var str = window.location.pathname
class AlbumSongs extends Component {
  constructor(props) {
    super(props)
  }
  render() {
str = window.location.pathname
str = str.replace("/", "")
    return (
      <div>
         {AlbumsData.map((card, index) => (
           <div>
             {card.title.replace(/\s+/g, '-').toLowerCase() === str ?
             <div>
             <h1 style={{color: "white"}}>{card.title}</h1>
             
             </div>
            :
            <h1 style={{color: "white"}}></h1>}
             </div>
         ))}
      </div>
    );
  }
}

export default AlbumSongs;